import { createSlice } from "@reduxjs/toolkit";
import { userTabs } from "../../../pages/Settings/UserManagement/Users/Json/UserJson";
import { UsersModalFieldsJSON } from "../../../pages/Settings/UserManagement/Users/Json/UsersFieldsJson";
import {
  AG_Mapping_FROM_DATE,
  AG_Mapping_TO_DATE,
  PSP_FROM_DATE,
  PSP_TO_DATE,
  USER_FROM_DATE,
  USER_TO_DATE,
} from "../../../Utils/FilterDateKeys";
import dateFormat from "dateformat";

const enterpriseid = localStorage.getItem("enterpriseid");

const initialState = {
  usersData: [],
  rolesData: [],
  usersRoleDropdown: [],
  organizationid: "",
  usersFieldJson: UsersModalFieldsJSON,
  selectedUser: {
    tabs: userTabs,
    activeTab: "details",
    detailsData: {},
    pspMappingData: [],
    agMappingData: [],
  },
  userEdit: {
    id: null,
  },
  sorting: {
    column: "created_date",
    order: "DESC",
  },

  filter: {
    filterApi: true,
    form: {
      // enterpriseid: enterpriseid,
      // [ORD_FROM_DATE]: dateFormat(new Date(), "yyyy-mm-dd"),
      // [ORD_TO_DATE]: dateFormat(new Date(), "yyyy-mm-dd"),
    },
    formCopy: {
      [USER_FROM_DATE]: dateFormat(new Date(), "yyyy-mm-dd"),
      [USER_TO_DATE]: dateFormat(new Date(), "yyyy-mm-dd"),
    },
  },
  pspSorting: {
    column: "created_date",
    order: "DESC",
  },
  pspMappingFilter: {
    filterApi: true,
    form: {
      // [PSP_FROM_DATE]: dateFormat(new Date(), "yyyy-mm-dd"),
      // [PSP_TO_DATE]: dateFormat(new Date(), "yyyy-mm-dd"),
    },
    formCopy: {
      [PSP_FROM_DATE]: dateFormat(new Date(), "yyyy-mm-dd"),
      [PSP_TO_DATE]: dateFormat(new Date(), "yyyy-mm-dd"),
    },
  },
  agSorting: {
    column: "created_date",
    order: "DESC",
  },
  agMappingFilter: {
    filterApi: true,
    form: {
      // [PSP_FROM_DATE]: dateFormat(new Date(), "yyyy-mm-dd"),
      // [PSP_TO_DATE]: dateFormat(new Date(), "yyyy-mm-dd"),
    },
    formCopy: {
      [AG_Mapping_FROM_DATE]: dateFormat(new Date(), "yyyy-mm-dd"),
      [AG_Mapping_TO_DATE]: dateFormat(new Date(), "yyyy-mm-dd"),
    },
  },
};

const usersSlice = createSlice({
  name: "users",
  initialState,
  reducers: {
    setUsersData(state, action) {
      state.usersData = action.payload;
    },
    setRolesData(state, action) {
      state.rolesData = action.payload;
    },
    setOrgId(state, action) {
      state.organizationid = action.payload;
    },
    changeActiveTab: (state, action) => {
      state.selectedUser.activeTab = action.payload;
    },
    setPspMappingData(state, action) {
      state.selectedUser.pspMappingData = action.payload;
    },
    setAgMappingData(state, action) {
      state.selectedUser.agMappingData = action.payload;
    },
    setUserEditID(state, action) {
      state.userEdit.id = action.payload;
    },
    setUsersFieldJson(state, action) {
      state.usersFieldJson = action.payload;
    },
    setUsersRoleDropdown(state, action) {
      state.usersRoleDropdown = action.payload;
    },
    setUserIdData: (state, action) => {
      state.selectedUser.detailsData = action.payload;
    },
    setUserSorting(state, action) {
      state.sorting = {
        column: action.payload?.column,
        order: action.payload?.order,
      };
    },
    setUserFilterApi(state, action) {
      state.filter.filterApi = action.payload;
    },
    setPspMappingFilterApi(state, action) {
      state.pspMappingFilter.filterApi = action.payload;
    },
    setAgMappingFilterApi(state, action) {
      state.agMappingFilter.filterApi = action.payload;
    },
    setUserFilterForm(state, action) {
      switch (action?.payload.type) {
        case "reset":
          state.filter.form = {
            // [USER_FROM_DATE]: dateFormat(new Date(), "yyyy-mm-dd"),
            // [USER_TO_DATE]: dateFormat(new Date(), "yyyy-mm-dd"),
          };
          state.filter.isFormChanged = true;
          state.filter.formCopy = state.filter.form;
          break;
        case "disableApplySpam":
          state.filter.isFormChanged = false;
          break;
        case "clearDate":
          delete state.filter.form[ORD_FROM_DATE];
          delete state.filter.form[ORD_TO_DATE];
          state.filter.isFormChanged = true;
          break;
        default:
          state.filter.form = {
            ...state.filter.form,
            [action.payload.name]: action.payload.value,
          };
          state.filter.isFormChanged = true;
      }
    },
    setPspMappingFilterForm(state, action) {
      switch (action?.payload.type) {
        case "reset":
          state.pspMappingFilter.form = {
            // [PSP_FROM_DATE]: dateFormat(new Date(), "yyyy-mm-dd"),
            // [PSP_TO_DATE]: dateFormat(new Date(), "yyyy-mm-dd"),
          };
          state.pspMappingFilter.isFormChanged = true;
          state.pspMappingFilter.formCopy = state.pspMappingFilter.form;
          break;
        case "disableApplySpam":
          state.pspMappingFilter.isFormChanged = false;
          break;
        case "clearDate":
          delete state.pspMappingFilter.form[PSP_FROM_DATE];
          delete state.pspMappingFilter.form[PSP_TO_DATE];
          state.pspMappingFilter.isFormChanged = true;
          break;
        default:
          state.pspMappingFilter.form = {
            ...state.pspMappingFilter.form,
            [action.payload.name]: action.payload.value,
          };
          state.pspMappingFilter.isFormChanged = true;
      }
    },
    setPspSorting(state, action) {
      state.pspSorting = {
        column: action.payload?.column,
        order: action.payload?.order,
      };
    },
    setAgMappingFilterForm(state, action) {
      switch (action?.payload.type) {
        case "reset":
          state.agMappingFilter.form = {
            // [AG_Mapping_FROM_DATE]: dateFormat(new Date(), "yyyy-mm-dd"),
            // [AG_Mapping_TO_DATE]: dateFormat(new Date(), "yyyy-mm-dd"),
          };
          state.agMappingFilter.isFormChanged = true;
          state.agMappingFilter.formCopy = state.agMappingFilter.form;
          break;
        case "disableApplySpam":
          state.agMappingFilter.isFormChanged = false;
          break;
        case "clearDate":
          delete state.agMappingFilter.form[AG_Mapping_FROM_DATE];
          delete state.agMappingFilter.form[AG_Mapping_TO_DATE];
          state.agMappingFilter.isFormChanged = true;
          break;
        default:
          state.agMappingFilter.form = {
            ...state.agMappingFilter.form,
            [action.payload.name]: action.payload.value,
          };
          state.agMappingFilter.isFormChanged = true;
      }
    },
    setAgSorting(state, action) {
      state.agSorting = {
        column: action.payload?.column,
        order: action.payload?.order,
      };
    },

    setPspMappingFilterFormCopy(state, action) {
      state.pspMappingFilter.formCopy = action.payload;
    },
    setAgMappingFilterFormCopy(state, action) {
      state.agMappingFilter.formCopy = action.payload;
    },
  },
});

export const {
  setUsersData,
  setRolesData,
  setOrgId,
  changeActiveTab,
  setPspMappingData,
  setAgMappingData,
  setUserEditID,
  setUsersFieldJson,
  setUsersRoleDropdown,
  setUserIdData,
  setUserFilterApi,
  setUserFilterForm,
  setUserSorting,
  setPspMappingFilterApi,
  setPspMappingFilterForm,
  setPspMappingFilterFormCopy,
  setPspSorting,
  setAgSorting,
  setAgMappingFilterApi,
  setAgMappingFilterForm,
  setAgMappingFilterFormCopy,
} = usersSlice.actions;

export default usersSlice.reducer;
